<kui-modal *ngIf="modalOpened" [isOpen]="modalOpened" (isOpenChange)="modalOpened = false" type="info">
  <kui-modal-invite [invite]="invite" (closeClicked)="modalOpened = false"></kui-modal-invite>
</kui-modal>

<ng-container [ngSwitch]="invite?.type">
  <ng-container *ngSwitchCase="inviteType.spouse">
    <p class="description">Being your best self is better, together.</p>
    <button
      class="button button-pill button-primary button-invite"
      [disabled]="!invite?.available || invite.available === 0"
      (click)="modalOpened = true">
      {{ invite?.available === 0 ? 'Spouse / Partner Invited' : 'Invite Spouse / Partner' }}
    </button>
  </ng-container>

  <ng-container *ngSwitchCase="inviteType.coworker">
    <p class="description">Help your teammates be their best selves.</p>
    <button
      class="button button-pill button-primary button-invite"
      [disabled]="!invite?.available || invite?.available === 0"
      (click)="modalOpened = true">
      Invite a Co-worker
    </button>
    <p class="invite-text">Invites Accepted: {{ invite?.accepted }}</p>
  </ng-container>

  <ng-container *ngSwitchCase="inviteType.friend">
    <p class="description">Earn a free invite for anyone when a co-worker accepts an invite!</p>
    <button
      class="button button-pill button-primary button-invite"
      [disabled]="!invite?.available || invite?.available === 0"
      (click)="modalOpened = true">
      Invite a Friend
    </button>
    <p class="invite-text">Invites Available: {{ invite?.available }}</p>
  </ng-container>
</ng-container>
